import {
  getSiteSection,
  pushToAdobeDataLayer,
} from "utils-lib/analytics/adobeDataLayer"

const DROP_OFF_LOCATION_FACILITY_SEARCH = "dropoff_location_facility_search"
const DROP_OFF_LOCATION_FACILITY_TYPE_TOGGLE =
  "dropoff_location_facility_type_toggle"
const DROP_OFF_LOCATION_FACILITY_LISTING_SELECTION =
  "dropoff_location_facility_listing_selection"

export const pushDropoffLocationFacilitySearch = ({
  suggest,
  facilityType,
  language,
}) => {
  const additionalData = {
    clicks: {
      object_content: {
        serviceAddress: suggest.formattedAddress,
        serviceZipCode: suggest.postalCode,
        facilityType,
      },
    },
    page: {
      siteSection: getSiteSection(language),
    },
  }
  pushToAdobeDataLayer(DROP_OFF_LOCATION_FACILITY_SEARCH, additionalData)
}

export const pushDropoffLocationFacilityTypeToggle = (
  facilityType,
  language,
) => {
  const additionalData = {
    clicks: {
      object_content: {
        facilityType,
      },
    },
    page: {
      siteSection: getSiteSection(language),
    },
  }
  pushToAdobeDataLayer(DROP_OFF_LOCATION_FACILITY_TYPE_TOGGLE, additionalData)
}

export const pushDropoffLocationFacilityListingSelection = (
  uniqueId,
  name,
  formattedAddress,
  language,
) => {
  const additionalData = {
    clicks: {
      object_content: {
        facilityID: uniqueId,
        facilityName: name,
        facilityAddress: formattedAddress,
      },
    },
    page: {
      siteSection: getSiteSection(language),
    },
  }
  pushToAdobeDataLayer(
    DROP_OFF_LOCATION_FACILITY_LISTING_SELECTION,
    additionalData,
  )
}
